import { motion } from 'framer-motion';
import type { ItemSummary } from '@/types';

interface ItemCardProps {
  item: ItemSummary;
  onOpen: (id: number) => void;
}

export function ItemCard({ item, onOpen }: ItemCardProps) {
  return (
    <motion.article
      layout
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -24 }}
      transition={{ duration: 0.25, ease: 'easeOut' }}
      whileTap={{ scale: 0.97 }}
      onClick={() => onOpen(item.id)}
      className="relative bg-kiosk-panel border border-kiosk-border rounded-2xl kiosk:rounded-kiosk overflow-hidden shadow-md shadow-black/5 cursor-pointer flex flex-col"
    >
      {Boolean(item.is_featured) && (
        <span className="absolute top-2 left-2 kiosk:top-[1.2vw] kiosk:left-[1.2vw] z-10 text-[0.65rem] kiosk:text-kiosk-xs font-semibold uppercase tracking-wide text-white bg-kiosk-highlight px-2 py-1 kiosk:px-[1.2vw] kiosk:py-[0.5vw] rounded-full">
          Kiemelt
        </span>
      )}
      {Boolean(item.is_all_day) && (
        <span className="absolute top-2 right-2 kiosk:top-[1.2vw] kiosk:right-[1.2vw] z-10 text-[0.65rem] kiosk:text-kiosk-xs font-semibold uppercase tracking-wide text-white bg-kiosk-accent2 px-2 py-1 kiosk:px-[1.2vw] kiosk:py-[0.5vw] rounded-full">
          Egésznapos
        </span>
      )}
      <div className="h-40 kiosk:h-[26vw] bg-kiosk-accent-soft/15">
        {item.cover_image && (
          <img src={item.cover_image} alt="" className="w-full h-full object-cover" />
        )}
      </div>
      <div className="px-4 py-3 kiosk:px-[1.8vw] kiosk:py-[1.6vw] flex-1 flex flex-col gap-1.5 kiosk:gap-[0.6vw]">
        <div className="text-kiosk-xs uppercase tracking-wide text-kiosk-accent2">{item.category_name}</div>
        <h3 className="font-display text-kiosk-base font-bold">{item.title}</h3>
        {item.short_description && (
          <p className="text-kiosk-xs text-kiosk-muted leading-snug">{item.short_description}</p>
        )}
      </div>
    </motion.article>
  );
}
